/**
 * The map-template API currently supports only these locales. New Core locales
 * should receive the English template catalog until localized templates exist.
 */
export const resolveMapTemplateLocale = (locale?: string): string => {
  if (locale === 'ko' || locale === 'en' || locale === 'ja') {
    return locale;
  }

  return 'en';
};
